// extracted by mini-css-extract-plugin
module.exports = {"picture":"Thumbnail_picture__IlhHB","img":"Thumbnail_img__1jmkG"};